var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviousPageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#493A08",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#222",
    d: "M16.5 3.5c7.179 0 13 5.82 13 13 0 7.179-5.821 13-13 13-7.18 0-13-5.821-13-13 0-7.18 5.82-13 13-13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M21.5 16.5h-9.255l2.27 2.27-.745.744-3.285-3.285.229-.23-.229-.229 3.285-3.285.745.743-2.272 2.272H21.5v1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPageIcon);
export default __webpack_public_path__ + "static/media/previous-page-icon.983b137ebf764bdb5823dcfc52c06d59.svg";
export { ForwardRef as ReactComponent };